import { useEffect, useState } from 'react';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import AddFormIcon from '../../assets/AddFormIcon';
import AddFormIconDark from '../../assets/AddFormIconDark';
import Accordion from '../../components/common/Accordian';
import useBgColorStore from '../../store/bgColor';
import Loader from '../../assets/loader/Loader';
import { translate } from '../../i18n';
import { IStaffAllocation } from '../../type/staffAllocation';
import useDateStore from '../../store/selectedDateStore';
import useLocationStore from '../../store/locatonStore';
import CrewForm from './CrewForm';
import CrewCard from './CrewCard';
import { IRouteDetails } from '../../type/routeDetails';
import { IBusDetails } from '../../type/busDetails';
import { IBalloonDetails } from '../../type/balloonDetails';
import { useCrewAllocation } from '../../hooks/apiHook/operationDetails';
type ModalType =
  | 'CrewForm'
  | 'DriverForm'
  | 'PilotForm'
  | 'EditFormFlight'
  | 'GeneralComment'
  | null;

interface CrewProps {
  routes: IRouteDetails[];
  buses: IBusDetails[];
  balloons: IBalloonDetails[];
  date: Date;
}

export default function CrewComponent({
  routes,
  buses,
  balloons,
  date,
}: CrewProps) {
  const [crewDetails, setCrewDetails] = useState<IStaffAllocation | null>(null);
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const { bgColor } = useBgColorStore();


  const [crewAccordionIsOpen, setCrewAccordionIsOpen] = useState<
    boolean | undefined
  >(false);
  const closeModal = () => setActiveModal(null);
  const [staffAllocation, setStaffAllocation] = useState<IStaffAllocation[]>();

  const handleStaffChange = (type: 'driver' | 'pilot' | 'crew' | 'booking') => {
    if (type === 'crew') {
      setCrewAccordionIsOpen(true);
      refetch();
    }
  };
  const [operationStaffId, setOperationStaffId] = useState<number>();
  const openModal = (modalType: ModalType, staff?: IStaffAllocation) => {
    setActiveModal(modalType);
    setCrewDetails(staff ?? null);
  };

  const handleOperationStaffIdChange = (operationStaffId: number) => {
    setOperationStaffId(operationStaffId);
  };

  const selectedLocation = useLocationStore((state) => state.selectedLocation);
  const {
    data: crewData,
    isLoading,
    refetch,
    isFetching,
  } = useCrewAllocation(selectedLocation.OwnerId, date);

  // To store in state if needed
  useEffect(() => {
    if (crewData) {
      setStaffAllocation(crewData);
    }
  }, [crewData]);

  return (
    <>
      <Accordion
        title="Crew Allocation"
        bgColor={`${bgColor}`}
        iconOpen={
          <div>
            <div className="block dark:hidden">
              <AccordianDownIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianDownIconDark />
            </div>
          </div>
        }
        iconClose={
          <div>
            <div className="block dark:hidden">
              <AccordianUpIcon />
            </div>
            <div className="hidden dark:block">
              <AccordianUpIconDark />
            </div>
          </div>
        }
        icon={
          <div>
            <div className="block dark:hidden">
              <AddFormIcon />
            </div>
            <div className="hidden dark:block">
              <AddFormIconDark />
            </div>
          </div>
        }
        accordionIsOpen={crewAccordionIsOpen}
        toggleState={setCrewAccordionIsOpen}
        formComponent={
          <CrewForm
            balloons={balloons || []}
            heading="Add Crew"
            closeModal={closeModal}
            crewList={staffAllocation || []}
            crewVehicleList={buses || []}
            onStaffChange={() => handleStaffChange('crew')}
            staffAllocation={staffAllocation || null}
            date={date}
          />
        }
      >
        {isLoading || isFetching ? (
          <div className="flex justify-center align-middle">
            <Loader />
          </div>
        ) : staffAllocation && staffAllocation.length > 0 ? (
          <CrewCard
            openModal={openModal}
            crewList={staffAllocation}
            onOperationStaffIdChange={handleOperationStaffIdChange}
            onStaffChange={() => handleStaffChange('crew')}
            crewVehicleList={buses || []}
          />
        ) : (
          <div className="text-center text-textColorGray p-4">
            {translate('operation.dataIsNotAvailable')}
          </div>
        )}

        {activeModal === 'CrewForm' && crewDetails && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-2">
            <CrewForm
              balloons={balloons || []}
              heading="Edit Crew Details"
              closeModal={closeModal}
              crewList={staffAllocation || []}
              crewVehicleList={buses || []}
              operationStaffId={operationStaffId}
              initialValues={crewDetails || undefined}
              onStaffChange={() => handleStaffChange('crew')}
              staffAllocation={staffAllocation || null}
              date={date}
            />
          </div>
        )}
      </Accordion>
    </>
  );
}
